import { useEffect, useRef, useState } from "react";
import {
  MUSIC_STATIONS, subscribeMusic,
  getMusicOn, setMusicOn, getStation, setStation,
  getMusicVolume, setMusicVolume,
} from "@/lib/audio";
import "./MusicButton.css";
import MyMusicPicker from "./MyMusicPicker";
import LiveRadioPicker from "./LiveRadioPicker";
// Small floating button (bottom-left, every page) that opens a music panel:
// on/off, station picker and volume. Built for touch screens.
export default function MusicButton() {
  const [, setTick] = useState(0);
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  useEffect(() => subscribeMusic(() => setTick((t) => t + 1)), []);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, [open]);
  const on = getMusicOn();
  const station = getStation();
  const vol = Math.round(getMusicVolume() * 100);
  const stepVol = (d) => {
    const next = Math.min(100, Math.max(0, vol + d));
    setMusicVolume(next / 100);
    if (next > 0 && !on) setMusicOn(true);
  };
  return (
    <div className="music-fab-wrap" ref={wrapRef}>
      {open && (
        <div className="music-panel" role="dialog" aria-label="Music" data-testid="music-panel">
          <div className="music-panel-head">
            <span className="music-panel-title">Music</span>
            <button
              type="button"
              className={`music-onoff${on ? " is-on" : ""}`}
              onClick={() => setMusicOn(!on)}
              data-testid="music-onoff"
            >
              {on ? "ON" : "OFF"}
            </button>
          </div>
          <div className="music-stations" role="group" aria-label="Station">
            {MUSIC_STATIONS.map((s) => (
              <button
                key={s.value}
                type="button"
                className={`music-station${on && station === s.value ? " is-active" : ""}`}
                onClick={() => setStation(s.value)}
                data-testid={`music-station-${s.value}`}
              >
                {s.label}
              </button>
            ))}
          </div>
          <MyMusicPicker compact />
          <LiveRadioPicker compact />
          <div className="music-vol">
            <button type="button" className="music-vol-btn" onClick={() => stepVol(-10)} aria-label="Quieter" data-testid="music-vol-down">−</button>
            <span className="music-vol-val" data-testid="music-vol-value">{vol}%</span>
            <button type="button" className="music-vol-btn" onClick={() => stepVol(10)} aria-label="Louder" data-testid="music-vol-up">+</button>
          </div>
        </div>
      )}
      <button
        type="button"
        className={`music-fab${on ? "" : " is-off"}`}
        onClick={() => setOpen((o) => !o)}
        aria-label={on ? "Music settings (music on)" : "Music settings (music off)"}
        data-testid="music-fab"
      >
        <span aria-hidden="true">{on ? "♪" : "🔇"}</span>
      </button>
    </div>
  );
}
